<template lang="html">
  <div id="product-detail-page" data-aos="fade">
    <section class="container main-section">
      <div class="row">
        <div class="col-12 col-info">
          <h2 class="mb-3 title-s1">Poliestireno alto impacto seriografía</h2>
        </div>

        <div class="col-lg-5 col-gallery">
          <div class="box-gallery">
            <img src="public/images/pages/products/product-1-xl.jpg">
          </div>
        </div>

        <div class="col-lg-7 col-info">
          <!-- <h2 class="mb-3 title-s1">Tira de exhibidora de impulso</h2> -->

          <div class="box-table">
            <h5 class="table-title">Propiedades Físicas Generales</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="td-label">Propiedad</th>
                    <th class="td-descr">Metodo de Prueba ASTM</th>
                    <th class="td-label">Unidades</th>
                    <th class="td-descr">Valor Tipico</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="td-label bg-1">Gravedad Específica</td>
                    <td class="td-descr bg-2">D 792</td>
                    <td class="td-label bg-1">g/cc</td>
                    <td class="td-descr bg-2">Valor Tipico</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4 box-table">
            <h5 class="table-title">Propiedades físicas mecánicas</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="td-label bg-1">Tension Superficial</td>
                    <td class="td-descr bg-2">D 638</td>
                    <td class="td-label bg-1">Dinas</td>
                    <td class="td-descr bg-2">34</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">Impacto Izod</td>
                    <td class="td-descr bg-2">D 256</td>
                    <td class="td-label bg-1">ft.lb/in</td>
                    <td class="td-descr bg-2">210</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">HDT</td>
                    <td class="td-descr bg-2">D 648</td>
                    <td class="td-label bg-1">°F</td>
                    <td class="td-descr bg-2">197</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4 box-table">
            <h5 class="table-title">Capacidad de procesos</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="td-label">Propiedad</th>
                    <th class="td-descr">Mínimo</th>
                    <th class="td-label">Máximo</th>
                    <th class="td-descr">Unidades</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="td-label bg-1">Calibre</td>
                    <td class="td-descr bg-2">0.012</td>
                    <td class="td-label bg-1">.120</td>
                    <td class="td-descr bg-2">pulgadas</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">Ancho</td>
                    <td class="td-descr bg-2">20</td>
                    <td class="td-label bg-1">126</td>
                    <td class="td-descr bg-2">centímetros</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">Largo</td>
                    <td class="td-descr bg-2">50</td>
                    <td class="td-label bg-1">130</td>
                    <td class="td-descr bg-2">centímetros</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">Peso de Rollo</td>
                    <td class="td-descr bg-2">30</td>
                    <td class="td-label bg-1">150</td>
                    <td class="td-descr bg-2">kg</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4 box-table">
            <h5 class="table-title">Capacidad de proceso</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="bg-2">Disponible en translucido, media opacidad y total opacidad.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Superficies matte-brillo,matte, brillo, coextrusiones.</td>
                  </tr>
                  <tr>
                    <td class="bg-2">Fabricación y corte de hojas a la medida.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4 box-table">
            <h5 class="table-title">Aplicaciones Típicas</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="bg-2">Impresión, impresión termoformado</td>
                  </tr>
                  <tr>
                    <td class="bg-1">P.O. P. impresión en  serigrafía</td>
                  </tr>
                  <tr>
                    <td class="bg-2">Fabricación y corte de hojas a la medida.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Usos industriales, suajado.</td>
                  </tr>
                  <tr>
                    <td class="bg-2">Cajas de luz, anuncios luminosos.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <p class="p-md mt-4 text-justify">
            Estos valores son típicos y representan un promedio sobre las pruebas y los muestreos realizados en muestra naturales usando procedimientos de uso común así como datos proporcionados por nuestros proveedores, estos datos. Se dan sin garantía, ya que es creíble y obtenida de fuentes creibles y exactas para procesos plásticos laminados.
          </p>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
}
</script>
